





















































/** Наружу идёт {logins, unassigned}: в запросе это два поля, служебное значение в них не попадает */
import { Component, Prop, Vue } from 'vue-property-decorator';

import { MmAuditor } from '../../types/domain';

const UNASSIGNED_VALUE = '__mm_assignment_unassigned__';

const KEY_PREFIX = 'priceMonitoring.mobileMonitoring.assignments.';

@Component
export default class AssignmentAuditorFilter extends Vue {
	@Prop({ default: () => [] }) readonly options!: MmAuditor[];

	/** Здесь логины, а не идентификаторы: числа бэкенд по auditorLogins не найдёт */
	@Prop({ default: () => [] }) readonly value!: string[];

	@Prop({ default: false }) readonly unassigned!: boolean;

	@Prop({ default: false }) readonly loading!: boolean;

	@Prop({ default: false }) readonly disabled!: boolean;

	@Prop({ default: '' }) readonly errorText!: string;

	UNASSIGNED_VALUE = UNASSIGNED_VALUE;

	get safeOptions(): MmAuditor[] {
		if (!this.options || this.options.length === 0) {
			return [];
		}

		return this.options.filter((item) => item != null && item.login != null && String(item.login) !== '');
	}

	get optionsByLogin(): { [key: string]: MmAuditor } {
		const index: { [key: string]: MmAuditor } = {};

		this.safeOptions.forEach((item) => {
			index[String(item.login)] = item;
		});

		return index;
	}

	get innerValue(): string[] {
		const selected = this.value ? this.value.slice() : [];

		return this.unassigned === true ? [UNASSIGNED_VALUE].concat(selected) : selected;
	}

	get labelText(): string {
		return this.$t(KEY_PREFIX + 'filterAuditor') as string;
	}

	get placeholderText(): string {
		return this.$t(KEY_PREFIX + 'filterAuditorAll') as string;
	}

	get unassignedLabel(): string {
		return this.$t(KEY_PREFIX + 'filterUnassigned') as string;
	}

	get retryText(): string {
		return this.$t('priceMonitoring.mobileMonitoring.states.retry') as string;
	}

	get errorMessage(): string {
		return this.errorText ? String(this.errorText).trim() : '';
	}

	fieldLabelId(field: string): string {
		return 'sm-mobilemon-assign-filter-' + field + '-label-' + String((this as any)._uid);
	}

	readFullName(auditor: MmAuditor): string {
		if (!auditor || !auditor.fullName) {
			return '';
		}

		return String(auditor.fullName).trim();
	}

	optionTitle(auditor: MmAuditor): string {
		const login = auditor && auditor.login ? String(auditor.login) : '';
		const fullName = this.readFullName(auditor);

		return fullName !== '' ? login + ' — ' + fullName : login;
	}

	/** ant зовёт эту функцию и игнорирует optionFilterProp из шаблона */
	filterOption(input: string, option: any): boolean {
		const query = input == null ? '' : String(input).trim().toLowerCase();

		if (query === '') {
			return true;
		}

		const value = this.readOptionValue(option);

		if (value === null) {
			return false;
		}

		if (value === UNASSIGNED_VALUE) {
			return this.unassignedLabel.toLowerCase().indexOf(query) >= 0;
		}

		const auditor = this.optionsByLogin[value];

		if (!auditor) {
			return false;
		}

		const login = auditor.login ? String(auditor.login).toLowerCase() : '';
		const fullName = auditor.fullName ? String(auditor.fullName).toLowerCase() : '';

		return login.indexOf(query) >= 0 || fullName.indexOf(query) >= 0;
	}

	/** Сентинел «без аудитора» уходит отдельным полем, в списке логинов его быть не должно */
	handleChange(next: any): void {
		const selected: string[] = Array.isArray(next) ? next.map((item: any) => String(item)) : [];

		this.$emit('change', {
			logins: selected.filter((item) => item !== UNASSIGNED_VALUE),
			unassigned: selected.indexOf(UNASSIGNED_VALUE) >= 0,
		});
	}

	handleRetry(): void {
		this.$emit('retry');
	}

	/** Пропы опции доступны только через componentOptions.propsData */
	private readOptionValue(option: any): string | null {
		if (!option || !option.componentOptions || !option.componentOptions.propsData) {
			return null;
		}

		const raw = option.componentOptions.propsData.value;

		return raw == null ? null : String(raw);
	}
}
